import { css } from 'styled-components';
import { rootGap } from './root';
export const wrapperBoxModel = () => css `
  box-sizing: border-box;
  width: 100%;
  display: flex;
  gap: ${rootGap}px;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
